import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';

/**
 * Whether the signed-in console login is an OWNER (the full console). An
 * ISSUER may only create tenants, add tills and issue licences. A profile
 * saved before roles existed has no role — every login was an owner then,
 * which is also what the API assumes.
 *
 * This only decides what the console SHOWS. The API is the real lock: it
 * refuses an issuer on everything else regardless of what the page offers.
 */
export function useIsOwner(): boolean {
  const { user } = useAuth();
  return user?.role !== 'ISSUER';
}

/** Owner-only page: an issuer who types the URL lands on Tenants instead. */
export function OwnerOnly({ children }: { children: ReactNode }) {
  return useIsOwner() ? <>{children}</> : <Navigate to="/cp/tenants" replace />;
}
